export default function SectionHeader({ kicker, title, lead, align = "left" }) {
  const alignCls =
    align === "center" ? "text-center items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col ${alignCls} max-w-3xl`}>
      {kicker && (
        <div className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-white/50 mb-4">
          {kicker}
        </div>
      )}
      <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
        {title}
      </h2>
      {lead && (
        <p className="mt-5 text-white/70 text-base md:text-lg leading-relaxed max-w-2xl">
          {lead}
        </p>
      )}
    </div>
  );
}
